import React, { useEffect } from "react";
import {
  MapContainer,
  ZoomControl,
  TileLayer,
  useMapEvents,
  useMap,
} from "react-leaflet";
import styles from "./mapLocationSelector.module.css";
import MapMarker from "../mapMarker/MapMarker";

export default function MapLocationSelector({
  location,
  setLocation,
  title,
  excerpt,
  autoOpen = false,
  draggable = true,
  zoom = 15,
  startCoords = { lat: 54.19581358242665, lng: -3.096303451814875 },
}) {
  // const startCoords = { lat: 54.19581358242665, lng: -3.096303451814875 };

  const addMarker = (newLocation) => {
    if (setLocation) {
      setLocation(newLocation);
    }
  };

  //map.panTo(new L.LatLng(40.737, -73.923));

  return (
    <MapContainer
      center={[startCoords.lat, startCoords.lng]}
      zoom={zoom}
      doubleClickZoom={true}
      scrollWheelZoom={true}
      attributionControl={false}
      zoomControl={false}
      className={styles.mapLocationSelector}
    >
      <LocationSelector onChange={addMarker} />
      <MapUpdateCenter startCoords={startCoords} zoom={zoom} />;
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <ZoomControl position="bottomleft" />
      <MapMarker
        location={location}
        setLocation={setLocation}
        title={title}
        excerpt={excerpt}
        autoOpen={autoOpen}
        draggable={draggable}
      />
    </MapContainer>
  );
}

function MapUpdateCenter({ startCoords, zoom }) {
  const map = useMap();

  useEffect(() => {
    // map.panTo(new L.LatLng(40.737, -73.923));
    map.flyTo([startCoords.lat, startCoords.lng], zoom);
  }, [startCoords, zoom, map]);

  return null;
}

function LocationSelector({ onChange }) {
  useMapEvents({
    click: (e) => onChange(e.latlng),
  });
  return null;
}
